import MenuItem from './MenuItem';

import { ReactComponent as PerformanceIcon } from '../../icons/performance.svg';
import { ReactComponent as EngageIcon } from '../../icons/ico-image_swap.svg';
import { ReactComponent as SecondPlayIcon } from '../../icons/second_play.svg';
import { ReactComponent as SearchIcon } from '../../icons/magnifyglass.svg';
import { ReactComponent as PlaylistIcon } from '../../icons/playlist.svg';
import { ReactComponent as PageIcon } from '../../icons/page.svg';
import MovieFilterIcon from '@mui/icons-material/MovieFilter';
import { OrganisationContext } from '../../App';
import { useContext } from 'react';

export default function Menu({ open }) {
  const { selectedOrganisationObject } = useContext(OrganisationContext);
  const orgtype = selectedOrganisationObject?.orgtype || [];
  return (
    <>
      <MenuItem open={open} path="/" end label="Dashboard">
        <PerformanceIcon />
      </MenuItem>
      <MenuItem open={open} path="/video-swap" label="Fast Match">
        <EngageIcon />
      </MenuItem>
      <MenuItem open={open} path="/promoted-content/1" label="Promoted Content">
        <SecondPlayIcon />
      </MenuItem>
      <MenuItem open={open} path="/headline-search" label="Headline Search">
        <SearchIcon />
      </MenuItem>
      <MenuItem open={open} path="/video-library" label="Video Library">
        <PlaylistIcon />
      </MenuItem>
      { orgtype.includes('rightsholder') && <MenuItem open={open} path="/pixels-studio" label="Pixels Studio">
        <MovieFilterIcon />
      </MenuItem>}
      <MenuItem open={open} path="/trends-and-videos" label="Trends & Videos">
        <PlaylistIcon />
      </MenuItem>
      <MenuItem open={open} path={`/playlist`} label="Playlists">
        <PlaylistIcon />
      </MenuItem>
      {/*<MenuItem open={open} path="/gap-analysis" label="Gap Analysis">*/}
      {/*  <InsightsIcon />*/}
      {/*</MenuItem>*/}
      <MenuItem open={open} path="/page-view" label="Page Views">
        <PageIcon height={24} />
      </MenuItem>
    </>
  );
}

export function DefaultSection() {
  return '/';
}
